import { ModuleProvider, useModule } from '#providers'
import { QuestionnaireModuleData } from './types/questionnaire.types'

export const QuestionnaireModuleProvider: typeof ModuleProvider<QuestionnaireModuleData> =
	ModuleProvider

export const useQuestionnaireModule: typeof useModule<QuestionnaireModuleData> =
	useModule
